import { useLocation, Navigate } from 'react-router-dom'
import { boolean } from 'boolean'

import { useAuth } from 'hooks/useAuth'

export function AuthGuard({ children }: { children: JSX.Element }) {
	const location = useLocation()
	const { token, authInfo, requireOtp, isModalLogin } = useAuth()

	if (requireOtp && !isModalLogin) {
		return <Navigate to="/auth/mfa" state={{ from: location }} replace />
	} else {
		if (token && authInfo) {
			const { isDeleted, isComplete } = authInfo
			if (boolean(isDeleted)) {
				return <Navigate to="/auth/recover" state={{ from: location }} replace />
			}
			if (!boolean(isComplete)) {
				return <Navigate to="/auth/sign-up-2" state={{ from: location }} replace />
			}
		}
	}
	return children
}
